import { render, staticRenderFns } from "./AntiAddictionSetting.vue?vue&type=template&id=0ed42398&"
import script from "./AntiAddictionSetting.vue?vue&type=script&lang=js&"
export * from "./AntiAddictionSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports